import type { Faq } from './schema'

/** The questions people ask before they write. Pages pick the ones that answer their own objection. */
export const faqs = {
  whatYouBuild: {
    question: 'What do you actually build?',
    answer:
      'GoHighLevel automation, AI automations on n8n, Zapier, and Make, CRM setup, funnels, custom websites, and small apps. Most of it for coaches and agencies who are losing leads to manual follow-up.',
  },
  startSpeed: {
    question: 'How fast can you start?',
    answer:
      'Same week for small fixes. Larger builds get a kickoff call within 48 hours. I work Manila time and overlap most US and EU schedules.',
  },
  needGhl: {
    question: 'Do I have to be on GoHighLevel?',
    answer:
      'No. Most of my work is GHL because that is where the certification is, but I have also built on Zapier, n8n, and custom CRMs. If your stack is a bad fit I will say so upfront.',
  },
  pricing: {
    question: 'How much do you charge?',
    answer:
      'Depends on the build. We hop on a discovery call so I can see the actual problem, then I send a written proposal with scope and price. No padded estimates.',
  },
  afterWrite: {
    question: 'What happens after I write?',
    answer:
      'I read it the same day and reply within one business day. You get a plan if I can automate it, or a straight no if I cannot.',
  },
} satisfies Record<string, Faq>

export const allFaqs: Faq[] = Object.values(faqs)
